/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ConversationModel } from "./ConversationModel";
import type { UniversalClinicVisitStatusResponse } from "./UniversalClinicVisitStatusResponse";

/**
 * Response body from Nori adding additional information to the Universal Clinic patient status response.
 */
export interface CuraiPatientStatusResponse {
  /** The unique Universal Clinic identifier for the patient. */
  patient_mrn: string | null;
  /** The ID for the external patient associated with this visit. */
  external_patient_id?: string | null;
  /** Whether or not the patient has completed their required video visit for establishing care with Curai. Required by some states before the patient can received text-based care. Otherwise, it is a prerequisite for billing insurance. */
  needs_video_visit?: boolean;
  /** The latest encounter this patient has had with Curai, if any. It may be an on-going encounter. */
  latest_visit?: UniversalClinicVisitStatusResponse | null;
  /** The conversation associated with the patient's current Curai visit */
  conversation: ConversationModel | null;
  /** The ID of the clinic request associated with the patient's current Curai visit */
  clinic_request_id?: string | null;
}
